import { mergeStyles } from "@fluentui/react";
import { useHashimukhTheme } from "./useHashimukhTheme";
export function mergeClasses() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    var merged = "";
    for (var i = 0, len = classes.length; i < len; i++) {
        var className = classes[i];
        if (!className)
            continue;
        merged += className;
    }
    return merged;
}
export var useClasses = function (maker) {
    var theme = useHashimukhTheme();
    var styles = maker(theme);
    var classes = {};
    Object.keys(styles).forEach(function (key) {
        classes[key] = mergeStyles(styles[key]);
    });
    return classes;
};
//# sourceMappingURL=useClasses.js.map